import { render } from "./PenIcon.vue?vue&type=template&id=7b6ce9f8"
import script from "./PenIcon.vue?vue&type=script&lang=js"
export * from "./PenIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__